import React from 'react';
import { Layout, Button, Space, Avatar, Dropdown, Typography } from 'antd';
import { LogoutOutlined, UserOutlined, ClockCircleOutlined, SettingOutlined } from '@ant-design/icons';
import { useNavigate } from 'react-router-dom';
import { useAuthStore } from '../../store/useAuthStore';
import NotificationSystem from '../notifications/NotificationSystem';

const { Header: AntHeader } = Layout;
const { Text } = Typography;

const Header = () => {
  const { user, logout } = useAuthStore();
  const navigate = useNavigate();

  const menuItems = [
    {
      key: 'profile',
      icon: <UserOutlined />,
      label: 'Profile',
      onClick: () => {
        if (user?.role === 'admin') {
          navigate('/admin/profile');
        } else if (user?.role === 'project_manager') {
          navigate('/project-manager/profile');
        } else {
          navigate('/profile');
        }
      },
    },
    ...(user?.role === 'admin' ? [{
      key: 'admin',
      icon: <SettingOutlined />,
      label: 'Admin Panel',
      onClick: () => navigate('/admin'),
    }] : []),
    {
      key: 'logout',
      icon: <LogoutOutlined />,
      label: 'Logout',
      onClick: logout,
    },
  ];

  return (
    <AntHeader className="bg-white shadow-sm border-b border-gray-200 px-4 sm:px-6 lg:px-8 w-full">
      <div className="flex items-center justify-between h-16 w-full">
        <div className="flex items-center space-x-3">
          <ClockCircleOutlined className="text-2xl text-blue-600" />
          <Text className="text-xl font-semibold text-gray-900 hidden sm:block">
            One Qodequay
          </Text>
        </div>

        <div className="flex items-center space-x-4">
          <NotificationSystem currentUser={user} />
          <Dropdown
            menu={{ items: menuItems }}
            placement="bottomRight"
            trigger={['click']}
          >
            <Button
              type="text"
              className="flex items-center space-x-2 p-2 hover:bg-gray-50 rounded-lg h-10 w-10"
              aria-label="User menu"
              title="Click to access profile and settings"
            >
              <Avatar 
                size={32}
                icon={<UserOutlined />}
                className="bg-blue-600 cursor-pointer flex items-center justify-center min-w-[32px]"
                style={{ display: 'flex' }}
              />
            </Button>
          </Dropdown>
        </div>
      </div>
    </AntHeader>
  );
};

export default Header;
